import { Tax } from '@/domain/Tax'
import DateUtils from '@/utils/DateUtils'

/**
 * 消費税管理サービス
 */
export default class TaxsService {
    /** インスタンス */
    private static _instance: TaxsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new TaxsService();
        }
        return this._instance;
    }

    /**
     * すべて取得
     */
    public findAll(): Tax[] {
        return [
            new Tax({id: 1, startOn: "1989-04-01", taxRate: 3.0}),
            new Tax({id: 2, startOn: "1997-04-01", taxRate: 5.0}),
            new Tax({id: 3, startOn: "2014-04-01", taxRate: 8.0}),
            new Tax({id: 4, startOn: "2019-10-01", taxRate: 10.0}),
        ]
    }

    /**
     * 指定日(YYYY-MM-DD)に有効な消費税率(%)を取得する
     */
    public findByActiveTax(date = DateUtils.instance.getToday()) {
        const tax = this.findAll()
                .filter(x => x.startOn <= date)
                .sort((a, b) => a > b ? 1 : -1)
                .map(x => x.taxRate)[0]

        return tax
    }
}
